import { IHasIntroducerAnswer, IIntroducerDetails, IIntroducerForm } from './types';

export function buildHasIntroducerAnswer(formData: IIntroducerForm): IHasIntroducerAnswer {
  if (formData.hasIntroducer !== 'true') {
    return {
      introducer: {},
    };
  }

  return {
    introducer: {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    },
  };
}

function hasIntroducerDetails(introducer: IIntroducerDetails | undefined): boolean {
  if (!introducer) {
    return false;
  }

  return Boolean(introducer.firstName || introducer.lastName || introducer.email || introducer.phoneNumber);
}

export function parseIntroducerFormFromSavedAnswer(
  savedAnswer: IHasIntroducerAnswer | undefined,
): Partial<IIntroducerForm> {
  const introducer = savedAnswer?.introducer;

  if (!introducer) {
    return {};
  }

  if (!hasIntroducerDetails(introducer)) {
    return {
      hasIntroducer: 'false',
    };
  }

  return {
    hasIntroducer: 'true',
    firstName: introducer.firstName ?? '',
    lastName: introducer.lastName ?? '',
    email: introducer.email ?? '',
    phoneNumber: introducer.phoneNumber ?? '',
  };
}
